import type { ReactNode } from "react";
import { Link } from "@tanstack/react-router";
import { ArrowRight } from "lucide-react";
import { useAuth } from "@/lib/auth-context";

/** Signup link for visitors, XAU Terminal (/dashboard) for signed-in members. Never /app. */
export function SignupOrTerminalLink({ children }: { children: ReactNode }) {
  const { user } = useAuth();
  if (user) {
    return (
      <Link to="/dashboard">
        Open XAU Terminal™ <ArrowRight className="h-4 w-4" />
      </Link>
    );
  }
  return (
    <Link to="/auth" search={{ tab: "signup" }}>
      {children}
    </Link>
  );
}
